import { RouteConfig } from 'vue-router';

import Terms from '@/views/terms/List.vue';

export const termsRoute: RouteConfig = {
  path: '',
  name: 'termsList',
  component: Terms,
  meta: {
    authorized: true
  }
};
